import { configureStore } from '@reduxjs/toolkit';
import dataReducer from './reducers/dataReducer';

export const store = configureStore({
  reducer: {
    data: dataReducer,
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      serializableCheck: false,
    });
  },
});
